module.exports = __webpack_public_path__ + "img/wlxxaq.48abfce.png";